import { deepDives } from "@/mocks/guagua";
import SectionHead from "./SectionHead";

const accentTag = ["bg-primary-100 text-primary-700", "bg-accent-100 text-accent-800", "bg-secondary-100 text-secondary-800"];

export default function DeepDive() {
  return (
    <section id="shenbao" className="scroll-mt-24 lg:scroll-mt-[132px] bg-foreground-950 text-background-50 py-12 md:py-16">
      <div className="max-w-[1240px] mx-auto px-4 md:px-6">
        <div className="text-center">
          <div className="inline-flex items-center gap-2 text-primary-400 text-xs md:text-sm font-medium tracking-wide">
            <span className="w-6 h-px bg-primary-400"></span>
            SHENBAO·BEIHOU
            <span className="w-6 h-px bg-primary-400"></span>
          </div>
          <h2 className="mt-3 font-heading font-bold text-2xl md:text-4xl text-background-50 leading-snug">
            热搜背后 · 营销号没敢说的
          </h2>
          <p className="mt-3 text-sm md:text-base text-background-300 max-w-2xl mx-auto">
            不追单点爆款，我们回看完整过程、还原时间线、比对多方信源。把被带节奏的热搜掰开揉碎，讲清营销号没敢说的部分。
          </p>
        </div>

        <div className="mt-10 grid md:grid-cols-2 gap-6">
          {deepDives.map((d, i) => (
            <article key={d.id} className="group grid grid-cols-1 sm:grid-cols-[200px_1fr] rounded-2xl overflow-hidden border border-background-800 bg-foreground-900 hover:border-primary-500/60 transition-colors">
              <div className="relative h-44 sm:h-auto overflow-hidden">
                <img
                  src={d.image}
                  alt={`${d.title} 深度调查资讯配图`}
                  loading="lazy"
                  className="absolute inset-0 w-full h-full object-cover object-top transition-transform duration-700 group-hover:scale-105"
                />
                <span className="absolute top-3 left-3 px-2.5 py-1 rounded-full bg-primary-500 text-background-50 text-xs font-semibold">
                  {d.label}
                </span>
              </div>
              <div className="p-5 md:p-6 flex flex-col">
                <h3 className="font-heading font-bold text-lg text-background-50 leading-snug group-hover:text-primary-300 transition-colors">
                  {d.title}
                </h3>
                <p className="mt-2.5 text-sm text-background-300 leading-relaxed line-clamp-4">{d.intro}</p>
                <div className="mt-3 flex flex-wrap gap-2">
                  {d.keywords.map((k, ki) => (
                    <span key={k} className={`px-2 py-0.5 rounded-md text-xs ${accentTag[ki % accentTag.length]}`}>
                      #{k}
                    </span>
                  ))}
                </div>
                <div className="mt-auto pt-4 flex items-center justify-between text-xs">
                  <span className="text-background-400 flex items-center gap-1">
                    <i className="ri-shield-check-line text-secondary-400"></i> {d.verified}
                  </span>
                  <span className="text-primary-300 inline-flex items-center gap-1">
                    看完整还原 <i className="ri-arrow-right-line"></i>
                  </span>
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}